var React = require('react');

function TestTube (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"64","height":"64","rx":"4","fill":"#1B68FF","key":0}),React.createElement("path",{"d":"M45.76 41.22l-7.44-11.78V20h.5a1.5 1.5 0 001.53-1.5v-1c0-.83-.68-1.5-1.52-1.5H25.62a1.5 1.5 0 00-1.53 1.5v1c0 .83.68 1.5 1.53 1.5h.5v9.44L18.7 41.22A4.44 4.44 0 0022.5 48h19.44a4.44 4.44 0 003.82-6.78zm-19-5.22l3.06-4.85c.23-.32.36-.72.36-1.15V20h4.07v10c0 .43.14.82.37 1.15L37.68 36H26.75z","fill":"#fff","key":1})]);
}

TestTube.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = TestTube;

TestTube.default = TestTube;
